import React from "react";

// Utility: escape JSON safely if needed
const safeJsonLd = (json) => {
  return JSON.stringify(json).replace(/<\/script>/g, '<\\/script>');
};

const EventStructuredData = ({
  title,
  description,
  startDate,
  endDate,
  vernissage,
  entranceCost,
  image,
  placeName,
  addressLine1,
  addressLine2,
  city,
  zipCode,
  country,
  latitude,
  longitude,
  organizerName = "Alberto Lussana",
  organizerUrl = "https://lussana.me",
}) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": title,
    "description": description,
    "startDate": startDate,
    "endDate": endDate,
    "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
    "eventStatus": "https://schema.org/EventScheduled",
    "location": {
      "@type": "Place",
      "name": placeName,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": `${addressLine1}${addressLine2 ? `, ${addressLine2}` : ""}`,
        "addressLocality": city,
        "postalCode": zipCode,
        "addressCountry": country,
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": latitude,
        "longitude": longitude,
      },
    },
    "image": Array.isArray(image)
      ? image.map((img) => img.formats?.large?.url || img.formats?.medium?.url || img.url)
      : [image?.formats?.large?.url || image?.formats?.medium?.url || image?.url],
    "offers": {
      "@type": "Offer",
      "url": organizerUrl,
      "price": entranceCost ?? 0,
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "validFrom": startDate,
    },
    "organizer": {
      "@type": "Person",
      "name": organizerName,
      "url": organizerUrl,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJsonLd(schema) }}
    />
  );
};

export default EventStructuredData;
